import { useParams } from 'react-router';
import { useQuery } from '@apollo/client/react';

import { GET_SETTLEMENT_OFFERS } from 'queries/settlements';
import { SETTLEMENT_OFFER_STATES } from 'utilities/constants';

export const OFFERS_TABS = Object.freeze({
  COLLECTIONS: 'collections',
  RECOVERIES: 'recoveries',
});

const ACTIVE_SETTLEMENT_STATES = [
  SETTLEMENT_OFFER_STATES.IN_PROGRESS,
  SETTLEMENT_OFFER_STATES.PENDING_CLOSE_OUT,
  SETTLEMENT_OFFER_STATES.FULFILLED,
];

// An account can't hold a settlement and a Preco offer at once, so only a
// settlement offer opens Recoveries; a Preco offer or no offer opens Collections.
const useDefaultOffersTab = () => {
  const { accountId, customerId } = useParams();

  const settlementsQuery = useQuery(GET_SETTLEMENT_OFFERS, {
    variables: { customerId, accountId },
    skip: !accountId || !customerId,
    fetchPolicy: 'cache-and-network',
  });

  if (!settlementsQuery.data && settlementsQuery.loading) {
    return { defaultTab: null, loading: true };
  }

  const hasActiveSettlement =
    settlementsQuery.data?.account?.offers?.offers?.some((offer) =>
      ACTIVE_SETTLEMENT_STATES.includes(offer?.data?.state),
    ) ?? false;

  return {
    defaultTab: hasActiveSettlement
      ? OFFERS_TABS.RECOVERIES
      : OFFERS_TABS.COLLECTIONS,
    loading: false,
  };
};

export default useDefaultOffersTab;
